import { IResourceConfig } from '@/Core/Contracts/UI'
import { DictionariesShell } from '../Components/DictionariesShell/DictionariesShell'
import { RegionViewTemplate } from '../Templates/RegionViewTemplate/RegionViewTemplate'
import { dictionaryDeleteConfirmText, dictionaryDetailButtons } from '../Helpers/dictionaryDelete'

export const ListRegionResource: IResourceConfig = {
    title: 'Регіони',
    fields: {
        id: {
            label: 'ID',
            type: 'number',
            inputProps: { disabled: true },
            /** У фільтрі: оператор (=, >, ≥, <, ≤) або діапазон від–до */
            isFilterRange: true,
        },
        title: {
            label: 'Назва',
            isRequired: true,
            type: 'string',
        },
        isActive: {
            label: 'Активний',
            type: 'switch',
        },
        /** Регіон завжди належить кластеру (cluster_id NOT NULL на бекенді) */
        cluster: {
            label: 'Кластер',
            isRequired: true,
            type: 'select',
            resource: 'Setting.ListCluster',
            /** У фільтрі — кілька кластерів (cluster in […]) */
            isFilterMultiple: true,
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
        code: {
            label: 'Код',
            isRequired: true,
            type: 'string',
            depFn: ({ formContext, field }) => {
                field.mergeInputProps({ disabled: formContext.values?.id > 0 })
            },
        },
        externalCode: {
            label: 'Унікальний код ERP',
            type: 'string',
        },
        sorting: {
            label: 'Сортування',
            type: 'number',
        },
    },
    filter: {
        includeFields: ['id', 'title', 'code', 'isActive', 'cluster', 'externalCode'],
    },
    /** Перегляд картки: поля + об'єкти виробництва й будівництва регіону; створення й редагування — стандартна форма */
    detailConfig: {
        /** «Видалити» в шапці картки (ядро дає лише пункт у меню рядка) */
        onButtons: dictionaryDetailButtons,
        modeConfig: {
            view: {
                template: RegionViewTemplate,
            },
        },
    },
    /** Картка колекції всередині оболонки розділу «Довідники» */
    layout: DictionariesShell,
    restUrl: '/services/lists/regions',
    pageUrl: '/settings/regions',
    primaryFieldCode: 'code',
    settings: {
        /** Попередження в підтвердженні видалення запису з ERP */
        deleteConfirmText: dictionaryDeleteConfirmText,
        searchFields: ['id', 'code', 'title'],
    },
}
